import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import { Check, Science } from "@mui/icons-material";
import { useShowTestJobsToggleViewModel } from "./ShowTestJobsToggle.vm";

/**
 * Account-menu switch that reveals test jobs on the ops surfaces that hide them by default (the
 * issues queues and the scheduling backlog). Rendered only for rogo admins — the caller gates it —
 * and the API enforces the same rule, so the item is a convenience, not the access control.
 *
 * A `menuitemcheckbox` rather than a `Switch` inside the row, for the same reason the theme picker
 * is three `MenuItem`s: it stays one stop in the `MenuList`'s roving-tabindex keyboard nav.
 */
export function ShowTestJobsToggle() {
	const vm = useShowTestJobsToggleViewModel();
	return (
		<MenuItem role="menuitemcheckbox" aria-checked={vm.showTestJobs} selected={vm.showTestJobs} onClick={vm.toggle}>
			<ListItemIcon>
				<Science />
			</ListItemIcon>
			<ListItemText>Show Test Jobs</ListItemText>
			{vm.showTestJobs && <Check fontSize="small" sx={{ ml: 2, color: "text.secondary" }} />}
		</MenuItem>
	);
}
